import { render } from "./DeployVM.vue?vue&type=template&id=2481acf7&scoped=true"
import script from "./DeployVM.vue?vue&type=script&lang=js"
export * from "./DeployVM.vue?vue&type=script&lang=js"

import "./DeployVM.vue?vue&type=style&index=0&id=2481acf7&lang=less&scoped=true"
import "./DeployVM.vue?vue&type=style&index=1&id=2481acf7&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2481acf7"]])

export default __exports__